const figure = (data) => {
	const figures = data.map(({ title: { rendered: figure }, acf: { description: label } }) => ({
		figure,
		label,
	}))

	return figures
}

export default figure
